import { queryOptions } from "@tanstack/react-query";
import {
  listOrganizationAthleteQuestionnaires,
  listOrganizationAthleteAvailableQuestionnaires,
  listOrganizationAthleteQuestionnaireSubmissions,
  getOrganizationAthleteQuestionnaireSubmission,
  assignOrganizationAthleteQuestionnaire,
  type Api,
} from "api-client";

import {
  type AthleteQuestionnaireSubmissions,
  type QuestionnairesRepository,
} from "./QuestionnairesRepository";
export function createOrganizationQuestionnairesRepository(
  organizationId: string,
): QuestionnairesRepository {
  const queryKey = ["organizations", organizationId, "athlete-questionnaires"];
  return {
    queryKey,
    listOptions(athleteId, pagination) {
      return queryOptions<Api.ListAthleteQuestionnaire.Output.Self>({
        queryKey: [...queryKey, athleteId, "list", pagination],
        async queryFn() {
          return (
            await listOrganizationAthleteQuestionnaires({
              path: { organizationId, athleteId },
              query: pagination,
            })
          ).data.data;
        },
      });
    },
    availableOptions(athleteId, query) {
      return queryOptions<Api.ListQuestionnaires.Output.Self>({
        queryKey: [...queryKey, athleteId, "available", query],
        async queryFn() {
          return (
            await listOrganizationAthleteAvailableQuestionnaires({
              path: { organizationId, athleteId },
              query: { query, pageSize: 100 },
            })
          ).data.data;
        },
      });
    },
    submissionsOptions(athleteId, questionnaireId, pagination) {
      return queryOptions<AthleteQuestionnaireSubmissions>({
        queryKey: [
          ...queryKey,
          athleteId,
          questionnaireId,
          "submissions",
          pagination,
        ],
        async queryFn() {
          return (
            await listOrganizationAthleteQuestionnaireSubmissions({
              path: { organizationId, athleteId, questionnaireId },
              query: pagination,
            })
          ).data.data;
        },
      });
    },
    submissionOptions(athleteId, questionnaireId, submissionId) {
      return queryOptions<Api.GetSubmission.Output.Self>({
        queryKey: [
          ...queryKey,
          athleteId,
          questionnaireId,
          "submission",
          submissionId,
        ],
        async queryFn() {
          return (
            await getOrganizationAthleteQuestionnaireSubmission({
              path: {
                organizationId,
                athleteId,
                questionnaireId,
                submissionId,
              },
            })
          ).data.data;
        },
      });
    },
    assign(athleteId, questionnaireId) {
      return assignOrganizationAthleteQuestionnaire({
        path: { organizationId, athleteId, questionnaireId },
      });
    },
  };
}
